import { newTerms } from "../../constants";

export function checkPaymentTerms(value){
    value = String(value);
    return Object.keys(newTerms).includes(value);
}



// WEBPACK FOOTER //
// ./src/reducers/helper/helperFunctions.js